import { CLASS_NAME_DEFAULT } from "../../constants"
import { BadgeProps } from "../../../types"

type WrapperProps = {
  children: React.ReactNode
  className?: string
  theme: "danger" | "success" | "warning" | "info" | "disabled" | "alt"
}

const Wrapper = ({
  children,
  theme,
  className = CLASS_NAME_DEFAULT
}: WrapperProps) => (
  <span className={`badge badge-${theme} ${className}`}>{children}</span>
)

const Danger = (props: BadgeProps) => {
  return <Wrapper {...props} theme="danger" />
}

const Info = (props: BadgeProps) => {
  return <Wrapper {...props} theme="info" />
}

const Warning = (props: BadgeProps) => {
  return <Wrapper {...props} theme="warning" />
}

const Success = (props: BadgeProps) => {
  return <Wrapper {...props} theme="success" />
}

const Disabled = (props: BadgeProps) => {
  return <Wrapper {...props} theme="disabled" />
}

const Alt = (props: BadgeProps) => {
  return <Wrapper {...props} theme="alt" />
}

const Badge = { Danger, Info, Warning, Success, Disabled, Alt }

export default Badge
